
function countDownClock() {
(function ($) {
  $(document).ready(function() {
    // countdown end date
    // only do if the clock is present
    if( $('#countdown-date').length ) {
      const dateFromHtml = $('#countdown-date .field-date time').html();
      const countDownDate = new Date(dateFromHtml);
      // had to change this when moving from twig to JS files for compilation process
      //const countDownDate = new Date("{{ content.field_date[0]['#markup']|date('M d, Y H:i:s') }}").getTime();

      const countCounting = setInterval(function() {

        let now = new Date().getTime();
        let timeLeft = countDownDate - now;

        let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor(timeLeft % (1000 * 60 * 60) / (1000 * 60));
        let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
        document.getElementById("days").innerHTML = days.toString().padStart(2, '0');
        document.getElementById("hours").innerHTML = hours.toString().padStart(2, '0');
        document.getElementById("minutes").innerHTML = minutes.toString().padStart(2, '0');
        document.getElementById("seconds").innerHTML = seconds.toString().padStart(2, '0');

        // message when the counter reaches the date
        if(timeLeft < 0) {
            clearInterval(countCounting);
            document.getElementById("days").innerHTML = "";
            document.getElementById("hours").innerHTML = "";
            document.getElementById("minutes").innerHTML = "";
            document.getElementById("seconds").innerHTML = "";
            document.querySelector(".counter-wrapper").style.display = 'none';
            document.getElementById("message").innerHTML = '<div class="h1 text-white">TODAY!</div></ br><div class="h4 text-white">' + countDownDate.toLocaleDateString() + ' ' + countDownDate.toLocaleTimeString() + '</p>';
        }
      }, 1000);
    }
  });
})(jQuery);
}

export{countDownClock}
